<script>
	import AuthContext from '../layouts/AuthContext.svelte';
	import { currentUser } from '../stores/currentUser';
	
</script>

<AuthContext>
	<div class="page">
        <div class="layout">
			<div class="layout__column">
				<div class="layout__item">
					Welcome to the home page {$currentUser.data.name}!
				</div>
			</div>
		</div>
	</div>
</AuthContext>